<template>
  <v-container>
    <v-card
      max-width="800"
      color="#F8F8F8"
      class="pa-2 px-6 mx-auto report-card my-4"
    >
      <v-card-text class="d-flex align-center mb-2">
        <v-icon class="mr-2">mdi-magnify</v-icon>
        <span class="subtitle"> {{ $t('Filtros de Busca') }} </span>
      </v-card-text>

      <v-row class="ma-0" dense>
        <v-col cols="12" lg="6">
          <label class="label ml-1">{{ $t('Instituição') }}</label>
          <v-autocomplete
            :search-input.sync="institutionSearch"
            @blur="institutionSearch = ''"
            hide-details="auto"
            :rules="[(v) => v.length <= 10 || 'Máximo de 10 instituições']"
            v-model="filter.institutionIds"
            :items="institutions"
            multiple
            item-text="name"
            @change="getUnidades"
            item-value="id"
            :loading="institutionLoading"
            outlined
            class="primary-input"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" lg="6">
          <label class="label ml-1">{{ $t('Unidade') }}</label>
          <v-autocomplete
            hide-details="auto"
            v-model="filter.unidadeId"
            :items="unidades"
            item-value="id"
            item-text="name"
            :loading="unidadeLoading"
            placeholder="Todas"
            outlined
            class="primary-input"
          ></v-autocomplete>
        </v-col>

        <v-col
          cols="12"
          class="d-flex align-center justify-center mb-2 flex-wrap"
        >
          <v-menu
            ref="startMenu"
            :close-on-content-click="false"
            :return-value.sync="filter.startDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(filter.startDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="filter.startDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="$refs.startMenu.save(filter.startDate)"
            >
            </v-date-picker>
          </v-menu>

          <span class="mx-2 subtitle"> {{ $t('até') }} </span>

          <v-menu
            ref="endMenu"
            :close-on-content-click="false"
            :return-value.sync="filter.endDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(filter.endDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="filter.endDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="$refs.endMenu.save(filter.endDate)"
            >
            </v-date-picker>
          </v-menu>
        </v-col>

        <v-col
          class="d-flex align-center justify-center mb-4 flex-wrap"
          cols="12"
        >
          <v-btn depressed class="secondary-button mr-1" @click="applyFilter">
            <span>{{ $t('Filtrar') }}</span>
            <v-icon class="ml-2">mdi-magnify</v-icon>
          </v-btn>

          <v-btn depressed class="clear-button ml-1" @click="reset">
            <span>{{ $t('Limpar') }}</span>
            <v-icon class="ml-2">mdi-cached</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-row class="ma-0" :key="filterKey">
      <v-col cols="12" sm="6">
        <EquipmentByInst :filter.sync="filter" />
      </v-col>
      <v-col cols="12" sm="6">
        <RequestByInst :filter.sync="filter" />
      </v-col>
      <v-col cols="12">
        <SolicitedConcluded :filter.sync="filter" />
      </v-col>
      <v-col cols="12">
        <CorrectiveScheduleExecuted :filter.sync="filter" />
      </v-col>
      <v-col cols="12">
        <InternalResolvability :filter.sync="filter" />
      </v-col>
      <v-col cols="12">
        <PreventiveCorrective :filter.sync="filter" />
      </v-col>
      <v-col cols="12">
        <PreventiveScheduleExecuted :filter.sync="filter" />
      </v-col>
      <v-col cols="12">
        <CalibrationScheduleExecuted :filter.sync="filter" />
      </v-col>
      <v-col cols="12">
        <ElectricalSafetyScheduleExecuted :filter.sync="filter" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import EquipmentByInst from './EquipmentsByInst/index.vue'
import RequestByInst from './RequestByInst/index.vue'
import CorrectiveScheduleExecuted from './CorrectiveScheduleExecuted/index.vue'
import InternalResolvability from './InternalResolvability/index.vue'
import PreventiveCorrective from './PreventiveCorrective/index.vue'
import PreventiveScheduleExecuted from './PreventiveScheduleExecuted/index.vue'
import CalibrationScheduleExecuted from './CalibrationScheduleExecuted/index.vue'
import ElectricalSafetyScheduleExecuted from './ElectricalSafetyScheduleExecuted/index.vue'
import SolicitedConcluded from './SolicitedConcluded/index.vue'
import moment from 'moment'

export default {
  data: () => ({
    institutionSearch: '',
    filter: {
      page: 1,
      pageSize: 10,
      institutionIds: [],
      unidadeId: null,
    },
    filterKey: false,
    apiService: new ApiService(),
    unidades: [],
    institutions: [],
    unidadeLoading: false,
    institutionLoading: false,
  }),

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    this.filter.institutionIds = [this.institutionId]
    this.getInstitutions()
  },

  components: {
    EquipmentByInst,
    RequestByInst,
    SolicitedConcluded,
    CorrectiveScheduleExecuted,
    InternalResolvability,
    PreventiveCorrective,
    PreventiveScheduleExecuted,
    CalibrationScheduleExecuted,
    ElectricalSafetyScheduleExecuted,
  },

  methods: {
    applyFilter() {
      if (this.filter.institutionIds.length > 10) {
        this.$toast.warning('Máximo de 10 instituições por filtro!')
        return
      }

      this.filterKey = !this.filterKey
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 10,
        institutionIds: [],
        unidadeId: null,
      }
      this.applyFilter()
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch((err) => {})
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .post(`unidade/listByIntitutionIds`, {
          ids: this.filter.institutionIds,
        })
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    setDates() {
      const startYear = this.startDate.split('-')[0]
      const startMonth = this.startDate.split('-')[1]
      const endYear = this.endDate.split('-')[0]
      const endMonth = this.endDate.split('-')[1]

      this.filter.startDate = moment(
        startYear + '-' + startMonth + '-' + 1
      ).format('yyyy-MM-DD')
      this.filter.endDate = moment(new Date(endYear, endMonth, 0)).format(
        'yyyy-MM-DD'
      )
    },
  },
}
</script>

<style></style>
